import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-probus.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "reset-password-code" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "reset-password-code--logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "reset-password-code--check-title" }, "Check your email", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "reset-password-code--check-text" }, " You will receive a code to verify, so you can reset your account password. ", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-block"
}, "Continue", -1)

import { ref } from 'vue'
import { useVerifyResetPassword } from '@/store/user'
import { toastError } from '@/store/toasts'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordCode',
  setup(__props) {

const codeInput = ref('')
const { verifyResetPassword, error } = useVerifyResetPassword()
const router = useRouter()

toastError(error)

const onSubmit = async () => {
  const code = codeInput.value
  await verifyResetPassword(code)
  router.push({
    name: 'reset_password',
    params: { code },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_FormControl = _resolveComponent("FormControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"]),
        class: "reset-password-code--form"
      }, [
        _createVNode(_component_FormControl, {
          modelValue: codeInput.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeInput).value = $event)),
          placeholder: "enter your code"
        }, null, 8, ["modelValue"]),
        _hoisted_7
      ], 40, _hoisted_6)
    ])
  ]))
}
}

})